var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.52734V14.5273",
    stroke: "#0195D3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0004 21.9386H5.94042C2.47042 21.9386 1.02042 19.4586 2.70042 16.4286L5.82042 10.8086L8.76042 5.52859C10.5404 2.31859 13.4604 2.31859 15.2404 5.52859L18.1804 10.8186L21.3004 16.4386C22.9804 19.4686 21.5204 21.9486 18.0604 21.9486H12.0004V21.9386Z",
    stroke: "#0195D3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9941 17.5273H12.0031",
    stroke: "#0195D3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrimeIcon);
export default __webpack_public_path__ + "static/media/crime-icon.8fe5fb585f25f418e241cede0f6b99ba.svg";
export { ForwardRef as ReactComponent };